import React, { Fragment, useEffect } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router";
import { ProgressBar } from "primereact/progressbar";
import { useSearchParams, useLocation, useParams } from "react-router-dom";
import { config as globalConfig } from "../../config";
import logo from "../../assets/images/logos/_Logo-Symple.svg";
import { updateBusinessLine } from "../../redux/actions/travel";

const TravelWrapperApplication = (props) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const creditCardSessionID = searchParams.get("cko-session-id");
  const loading = useSelector((state) => state.travel.loading);
  const isLoggedIn = useSelector((state) => state.travel.isLoggedIn);
  const uid = searchParams.get("uid");
  const lang = searchParams.get("lang") || localStorage.getItem("TawunLang");
  const { i18n } = useTranslation();
  const  {businessLine} = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
      document.body.dir = "ltr";
    } else {
      i18n.changeLanguage("ar");
      document.body.dir = "rtl";
    }
  }, []);

  useEffect(() => {
    dispatch(updateBusinessLine(businessLine))
  }, [businessLine]);

  // if (!isLoggedIn && !creditCardSessionID && !["/travel", "/travel/","/travel/success","/travel/failed","/travel/summary"].includes(location.pathname)) {
  //   window.location.href = globalConfig.prefixRouting + "travel";
  //   // navigate("/renewal",{replace:true});
  //   return <Outlet />;
  // }

  return (
    <Fragment>
      {loading && (
        <>
          <div className="loader-overlay">
            <img src={logo} alt="" />
          </div>
          <ProgressBar
            mode="indeterminate"
            style={{ height: "6px" }}
          ></ProgressBar>
        </>
      )}
      <props.component {...props} />
    </Fragment>
  );
};

export default withTranslation()(TravelWrapperApplication);
